import { useQuery } from '@apollo/client';
import { READ_CUSTOMER_PMCS_DETAILS } from 'graphql/queries/readCustomerPmcsDetails';
import React, { ReactNode } from 'react';
import { useActiveElementStore } from 'stores/activeElementStore';
import {
  Query,
  QueryParkZoneArgs,
  QueryReadCustomerPmcsArgs,
} from 'types/generatedSchemaTypes';
import { sortPmcsByVisibility } from 'utils/permitUtils';
import LongTermParkingContext from './LongTermParkingContext';
import { GET_PARK_ZONE } from '@queries/getParkZone.ts';

const LongTermParkingProvider = ({ children }: { children: ReactNode }) => {
  const parkingZoneUid = useActiveElementStore((state) => state.activeElement);

  const { data, loading, error } = useQuery<Query, QueryReadCustomerPmcsArgs>(
    READ_CUSTOMER_PMCS_DETAILS,
    {
      variables: {
        input: {
          parkingZoneUids: [parkingZoneUid],
          permitType: 'SALES_ORDER',
        },
      },
      skip: !parkingZoneUid,
      fetchPolicy: 'cache-and-network',
    }
  );

  const parkingZoneResult = useQuery<Query, QueryParkZoneArgs>(GET_PARK_ZONE, {
    variables: { uid: parkingZoneUid },
    fetchPolicy: 'cache-and-network',
  });

  const values = {
    selectedPmcs: sortPmcsByVisibility(data?.readCustomerPmcs),
    loading,
    error,
    parkingZoneResult,
  };

  return (
    <LongTermParkingContext.Provider value={values}>
      {children}
    </LongTermParkingContext.Provider>
  );
};

export default LongTermParkingProvider;
